var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Text, View } from 'elements';
import { T } from 'helpers/i18n';
import { Catalog } from '../../Settings/SettingsStore';
import theme, { hairline } from '../../../Theme';
import { styleTouchable } from '../../OperationLines/container/OperationLinesContainer';
import Touchable from '../../../elements/Touchable';
import StretchesList from './StretchesList';
import { TypeTicket } from '../../Detail/DetailRoutes';
import { SearchInput } from '../../../components';
let StretchesPacketsContainer = class StretchesPacketsContainer extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            searchTerm: '',
            selected: this.props.store.settingsStore.saleSelected || Catalog.Stretches
        };
        this.handleSearch = (searchTerm) => {
            this.setState({ searchTerm });
        };
        this.toggleBusinessUnits = () => {
        };
    }
    componentDidMount() {
        // console.log('StretchesContainer - componentDidMount')
        this.props.store.businessUnits.read();
    }
    handleCatalogSelected(value) {
        this.props.store.settingsStore.setSaleSelected(value);
        this.setState({ selected: value });
    }
    render() {
        const { searchTerm, selected } = this.state;
        return (React.createElement(View, { flex: true },
            React.createElement(View, { row: true, center: true, style: Object.assign({}, hairline.bottom) },
                React.createElement(Touchable, { style: styleTouchable, onClick: () => {
                        this.handleCatalogSelected(Catalog.Stretches);
                    } },
                    React.createElement(Text, { style: { color: selected === Catalog.Stretches ? theme.color.primary : undefined }, center: true }, T('services'))),
                React.createElement(Touchable, { style: styleTouchable, onClick: () => {
                        this.handleCatalogSelected(Catalog.Packets);
                    } },
                    React.createElement(Text, { style: { color: selected === Catalog.Packets ? theme.color.primary : undefined }, center: true }, T('packets')))),
            React.createElement(SearchInput, { onChange: (value) => { this.setState({ searchTerm: value }); } }),
            React.createElement(View, { row: true, style: hairline.bottom }),
            selected === Catalog.Stretches &&
                React.createElement(StretchesList
                // id={this.props.match.params.id}
                , Object.assign({ 
                    // id={this.props.match.params.id}
                    searchTerm: searchTerm, typeList: TypeTicket.Stretch }, this.props)),
            selected === Catalog.Packets &&
                React.createElement(StretchesList
                // id={this.props.match.params.id}
                , Object.assign({ 
                    // id={this.props.match.params.id}
                    searchTerm: searchTerm, typeList: TypeTicket.Packet }, this.props))));
    }
};
StretchesPacketsContainer = __decorate([
    inject('store'),
    observer
], StretchesPacketsContainer);
export default StretchesPacketsContainer;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Stretches/container/StretchesPacketsContainer.tsx
// module id = 542
// module chunks = 0